var _use, _g, _use2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClientConnectUsageReferral(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 35,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path0_stroke",
    transform: "matrix(.7353 0 0 .7353 14.03 13.824)",
    width: "100%",
    height: "100%"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.7353 0 0 .7353 -3572 -389.67)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "a"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path1_fill",
    transform: "translate(4862 538.75)",
    width: "100%",
    height: "100%",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path2_stroke_2x",
    transform: "translate(4862 538.75)",
    width: "100%",
    height: "100%"
  })))), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path3_fill",
    transform: "matrix(.7353 0 0 .7353 6.463 9.93)",
    width: "100%",
    height: "100%"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path0_stroke",
    d: "M14.51 14.75v-1h-.278l-.238.143zm-9.02 0l.516-.857-.238-.143H5.49zm-.74-8.5C4.75 3.35 7.1 1 10 1v-2a7.25 7.25 0 0 0-7.25 7.25zM10 11.5a5.25 5.25 0 0 1-5.25-5.25h-2A7.25 7.25 0 0 0 10 13.5zm5.25-5.25c0 2.9-2.35 5.25-5.25 5.25v2a7.25 7.25 0 0 0 7.25-7.25zM10 1c2.9 0 5.25 2.35 5.25 5.25h2A7.25 7.25 0 0 0 10-1zm5.625 12.75H14.51v2h1.115zM21 19.125a5.375 5.375 0 0 0-5.375-5.375v2A3.375 3.375 0 0 1 19 19.125zm0 .938v-.938h-2v.938zM19.062 22c1.07 0 1.938-.867 1.938-1.938h-2c0-.034.028-.062.063-.062zM.938 22h18.125v-2H.938zM-1 20.062C-1 21.133-.132 22 .938 22v-2c.034 0 .062.028.062.063zm0-.937v.938h2v-.938zm5.375-5.375A5.375 5.375 0 0 0-1 19.125h2a3.375 3.375 0 0 1 3.375-3.375zm1.115 0H4.375v2H5.49zm8.504.143a7.754 7.754 0 0 1-7.988 0l-1.031 1.714a9.754 9.754 0 0 0 10.05 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1_fill",
    d: "M14.53 12.624a8 8 0 1 0-6.138 3.367c.045.006.09.009.137.009h6z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2_stroke_2x",
    d: "M14.53 12.624l-1.632-1.158-.369.52v.638zM8.391 15.99l.274-1.982-.184-.025-.186.009zm6.137.009v2h2v-2zM14 8a5.963 5.963 0 0 1-1.102 3.466l3.262 2.315A9.964 9.964 0 0 0 18 8zM8 2a6 6 0 0 1 6 6h4C18 2.477 13.523-2 8-2zM2 8a6 6 0 0 1 6-6v-4C2.477-2-2 2.477-2 8zm6 6a6 6 0 0 1-6-6h-4c0 5.523 4.477 10 10 10zm.296-.007A6.191 6.191 0 0 1 8 14v4c.164 0 .326-.004.487-.012zm.233.007c.044 0 .09.003.137.01l-.549 3.962c.137.019.275.028.412.028zm6 0h-6v4h6zm-2-1.376V16h4v-3.376z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3_fill",
    d: "M6.412 2.882H3.706V.176A.177.177 0 0 0 3.529 0h-.47a.177.177 0 0 0-.177.176v2.706H.176A.177.177 0 0 0 0 3.06v.47c0 .097.08.177.176.177h2.706v2.706c0 .097.08.176.177.176h.47c.097 0 .177-.08.177-.176V3.706h2.706c.097 0 .176-.08.176-.177v-.47a.177.177 0 0 0-.176-.177z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientConnectUsageReferral);
export default __webpack_public_path__ + "static/media/ClientConnectUsage_referral.dc95fe9d8b2200e4e3d0da77eafc53ce.svg";
export { ForwardRef as ReactComponent };